module.exports = __webpack_public_path__ + "static/media/National-Hurricane-Center.40f54db5.jpg";